import { apiClient } from './client'

export type TimePeriod = 'current_month' | 'last_month' | 'last_2_months' | 'last_3_months'

export const TIME_PERIODS: Array<{ value: TimePeriod; label: string }> = [
  { value: 'current_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'last_2_months', label: 'Two months ago' },
  { value: 'last_3_months', label: 'Three months ago' },
]

export interface VideoListRow {
  card_id: number
  card_title: string
  card_status: string
  creation_time: string
  due_date: string | null
  video_tag_type: 'SF' | 'LF'
  video_list_tag_type_count: string | number | null
  creditCount: number | string
  client_fullname: string | null
  qa_fullname: string | null
  lead_fullname: string | null
}

export interface VideoListResponse {
  cards: VideoListRow[]
  totalVideoCreditCount: number | string
}

export interface ArchivedRow {
  card_id: number
  card_title: string
  client_name: string
  subscription_type: string | null
  archived_time: string
  creation_time: string
  done_time: string | null
  assigned_time?: string | null
  qa_assigned_to?: number | null
  assigned_to: string | null
  done_video_link: string | null
  rating: number | string | null
}

export interface ExportRow {
  card_title: string
  card_status: string
  creation_time: string
  customerFirstName: string | null
  customerLastName: string | null
  qaFirstName: string | null
  qaLastName: string | null
}

export const videoListApi = {
  list: (params: { time_period: TimePeriod; viewAs?: string | number }) =>
    apiClient
      .get<VideoListResponse>('/api/getWebsiteCards', {
        params: { time_period: params.time_period, viewAs: params.viewAs || 'All Customers' },
      })
      .then((r) => r.data),
  archived: (params: { client_id?: string | number; searchTitle?: string; limit: number; page: number }) =>
    apiClient
      .get<ArchivedRow[]>('/api/cards/archive', {
        params: { client_id: params.client_id || 0, searchTitle: params.searchTitle || '', limit: params.limit, page: params.page },
      })
      .then((r) => (Array.isArray(r.data) ? r.data : [])),
  exportCards: (params: { limit?: number | null; customerId?: string | number; start_date: string; end_date: string }) =>
    apiClient
      .get<ExportRow[]>('/api/exportCardAsCsv', {
        params: {
          limit: params.limit ?? '',
          customerId: params.customerId ?? '',
          start_date: params.start_date,
          end_date: params.end_date,
        },
      })
      .then((r) => (Array.isArray(r.data) ? r.data : [])),
}
